import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const AREAS = [
  { slug: "ealing", name: "Ealing" },
  { slug: "richmond", name: "Richmond" },
  { slug: "chiswick", name: "Chiswick" },
  { slug: "wimbledon", name: "Wimbledon" },
  { slug: "hampstead", name: "Hampstead" },
  { slug: "croydon", name: "Croydon" },
];

const SERVICES = [
  { slug: "house-extensions-london", name: "House Extensions" },
  { slug: "loft-conversions-london", name: "Loft Conversions" },
  { slug: "kitchen-renovations-london", name: "Kitchen Renovations" },
  { slug: "bathroom-renovations-london", name: "Bathroom Renovations" },
  { slug: "full-house-renovations-london", name: "Full House Renovations" },
  { slug: "new-build-contractors-london", name: "New Build Contractors" },
  { slug: "structural-work-london", name: "Structural Work" },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid md:grid-cols-2 lg:grid-cols-5 gap-12">
        <div className="lg:col-span-1">
          <div className="font-display text-white text-2xl font-bold tracking-tight">
            Prime Build Design
          </div>
          <div className="overline mt-1 text-slate-500">Est. 2014 · London</div>
          <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-xs">
            Premium domestic construction company crafting homes with precision, integrity and a
            decade of proven craftsmanship across London.
          </p>
        </div>

        <div>
          <div className="text-white text-sm uppercase tracking-[0.2em] mb-5">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link className="hover:text-[#C5A059] transition" to="/about" data-testid="footer-link-about">About</Link></li>
            <li><Link className="hover:text-[#C5A059] transition" to="/services" data-testid="footer-link-services">Services</Link></li>
            <li><Link className="hover:text-[#C5A059] transition" to="/projects" data-testid="footer-link-projects">Projects</Link></li>
            <li><Link className="hover:text-[#C5A059] transition" to="/blog" data-testid="footer-link-blog">Insights</Link></li>
            <li><Link className="hover:text-[#C5A059] transition" to="/estimator" data-testid="footer-link-estimator">AI Estimator</Link></li>
            <li><Link className="hover:text-[#C5A059] transition" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white text-sm uppercase tracking-[0.2em] mb-5">Services</div>
          <ul className="space-y-3 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link className="hover:text-[#C5A059] transition" to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`}>
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white text-sm uppercase tracking-[0.2em] mb-5">Areas we cover</div>
          <ul className="space-y-3 text-sm">
            {AREAS.map((a) => (
              <li key={a.slug}>
                <Link className="hover:text-[#C5A059] transition" to={`/areas/${a.slug}`} data-testid={`footer-area-${a.slug}`}>
                  Builders in {a.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white text-sm uppercase tracking-[0.2em] mb-5">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3">
              <Phone size={16} className="text-[#C5A059] mt-0.5 flex-shrink-0" />
              <a href="tel:+447481626260" className="hover:text-white" data-testid="footer-phone">07481 626 260</a>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="text-[#C5A059] mt-0.5 flex-shrink-0" />
              <a href="mailto:primebuilddesignltd9@gmail.com" className="hover:text-white break-all" data-testid="footer-email">primebuilddesignltd9@gmail.com</a>
            </li>
            <li className="flex gap-3">
              <MapPin size={16} className="text-[#C5A059] mt-0.5 flex-shrink-0" />
              <span>45 Bridge Road,<br />Wembley Park, HA9 9AG</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Prime Build Design LTD. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-slate-300">Admin</Link>
            <span>Registered in England & Wales</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
